export class TokenRequest {

    grant_type: string = 'authorization_code';
    code: string;
    code_verifier: string;

}